import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import { useRefundConfigTemplateProvider } from '../RefundConfigTemplate.Hooks';

export default function RefundConfigTemplateDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useRefundConfigTemplateProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.internalName}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
